import request from "@/utils/request";

// 查询系统管理-业务操作日志列表
export function listBusinessOperationLog(data) {
  return request({
    url: "/system/businessOperationLog/list",
    method: "post",
    data: data
  });
}

// 分页查询系统管理-审核日志列表
export function auditLog(data) {
  return request({
    url: "/system/auditLog/list",
    method: "POST",
    data
  });
}
